<template lang="pug">
.job-site-action
  vue-popper(
    v-if="isWorkOrder"
    :append-to-body="appendBody"
    :options="{ placement }"
  )
    .tooltip.popper
      .tooltip-inner
        p.mb-5
          | This job site belongs to a work order and must be edited as part of it
        a.in-tooltip(:href="editWorkOrderUrl")
          i.hi.hi-12.hi-edit-xs.mr-5
          | Edit work order
    template(#reference)
      a.btn.btn-transparent.btn-icon.btn-xs(
        disabled
      )
        i.hi.hi-12(:class="iconClass")
  a.btn.btn-transparent.btn-icon.btn-xs(
    v-else
    @click.prevent.stop="$emit('click')"
  )
    i.hi.hi-12(:class="iconClass")
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    placement: {
      type: String,
      default: 'left',
    },
    appendBody: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    ...mapState({
      organization: 'organization',
    }),
    iconClass() {
      return `hi-${this.icon}-xs`;
    },
    isWorkOrder() {
      return this.item.is_work_order;
    },
    editWorkOrderUrl() {
      return this.isWorkOrder ? `/organizations/${this.organization.id}/work_orders/${this.item.project_id}` : null;
    },
  },
};
</script>
